import { defineComponent as _defineComponent } from 'vue'
import BankLogo from '@/components/calculator/BankLogo.vue';
import { SimulationDemand } from '@/models/Demand';
import Offer from '@/models/Offer';
import { useSimulationStore } from '../services/SimulationStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferDetailsShort',
  props: {
    offer: { default: () => new Offer() },
    userInput: null
  },
  setup(__props: any) {

const props = __props as { offer: Offer, userInput: SimulationDemand }



const store = useSimulationStore();

return { __sfc: true,props, store, BankLogo }
}

})